import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import cervical from "../assets/ceQueJeSoigne/cervical.png";
import migraines from "../assets/ceQueJeSoigne/migrainesEtCephalees.png";
import digestif from "../assets/ceQueJeSoigne/patholigies digestives.png";
import rachis from "../assets/ceQueJeSoigne/rachis.png";
import sciatiqueImg from "../assets/newImg/sciatique.png";
import sciatiqueCard from "../assets/ceQueJeSoigne/sciatiqueNerf.png";
import hernieDiscaleImg from "../assets/newImg/hernieDiscale.png";
import tendiniteImg from "../assets/newImg/tendinites.png";
import tendiniteCard from "../assets/ceQueJeSoigne/tendiniteSport.png";
import bebe from "../assets/newImg/bebe.png";
import enceinte from "../assets/newImg/femme enceinte.png";
import sportif from "../assets/newImg/sportif.png";
import SEO from "../components/SEO";
import { SX } from "../sx";
import { C, F, R, S, maxW, trans } from "../tokens";

const PATHOS = [
  {
    tag: "Rachis",
    title: "Douleurs du dos",
    img: rachis,
    count: "7 symptômes",
    items: [
      "Lombalgie chronique ou aiguë",
      "Lumbago",
      "Hernie discale",
      "Dorsalgie",
      "Scoliose fonctionnelle",
      "Tensions musculaires",
      "Raideur matinale",
    ],
  },
  {
    tag: "Cervical",
    title: "Cervicales & nuque",
    img: cervical,
    count: "5 symptômes",
    items: [
      "Cervicalgie",
      "Torticolis",
      "Névralgie cervico-brachiale",
      "Maux de tête d'origine cervicale",
      "Vertiges positionnels",
    ],
  },
  {
    tag: "Neurologique",
    title: "Migraines & céphalées",
    img: migraines,
    count: "4 symptômes",
    items: [
      "Migraines récurrentes",
      "Céphalées de tension",
      "Sinusites fonctionnelles",
      "Névralgies faciales",
    ],
  },
  {
    tag: "Digestif",
    title: "Pathologies digestives",
    img: digestif,
    count: "5 symptômes",
    items: [
      "Reflux gastro-œsophagien",
      "Troubles du transit",
      "Colon irritable",
      "Ballonnements chroniques",
      "Dysfonctions hépatiques",
    ],
  },
  {
    tag: "Neurologique",
    title: "Sciatique & nerfs",
    img: sciatiqueCard,
    count: "4 symptômes",
    items: [
      "Sciatique",
      "Cruralgie",
      "Syndrome du canal carpien",
      "Névralgie intercostale",
    ],
  },
  {
    tag: "Sport",
    title: "Tendinites & sport",
    img: tendiniteCard,
    count: "6 symptômes",
    items: [
      "Tendinite rotulienne",
      "Entorse ancienne",
      "Syndrome de l'essuie-glace",
      "Épicondylite",
      "Préparation physique",
      "Récupération post-blessure",
    ],
  },
];

const PROFILS = [
  {
    name: "Nourrissons & bébés",
    img: bebe,
    to: "/pathologies/nourrissons",
    imgPos: "center 25%",
  },
  {
    name: "Femmes enceintes",
    img: enceinte,
    to: "/pathologies/femme-enceinte",
  },
  { name: "Sportifs", img: sportif, to: "/pathologies/sportifs" },
  { name: "Sciatique", img: sciatiqueImg, to: "/pathologies/sciatique" },
  { name: "Hernie discale", img: hernieDiscaleImg, to: "/pathologies/hernie-discale" },
  { name: "Tendinites", img: tendiniteImg, to: "/pathologies/tendinite" },
];

const WARNING_ITEMS = [
  { icon: "🦴", title: "Fracture récente non consolidée",    desc: "Un bilan radiologique récent est nécessaire avant toute manipulation." },
  { icon: "🔬", title: "Pathologie oncologique en cours",    desc: "Suivi médical requis — l'ostéopathie peut rester complémentaire." },
  { icon: "🌡️", title: "Infection aiguë ou fièvre",          desc: "Attendez la guérison complète avant la séance." },
  { icon: "❤️", title: "Douleur thoracique inexpliquée",     desc: "Consultation cardiologique recommandée en priorité." },
  { icon: "🧠", title: "AVC ou accident vasculaire récent",  desc: "Période de convalescence médicale nécessaire." },
];

const PathoCard = ({ patho }) => {
  const [open, setOpen] = useState(false);
  return (
    <Box
      sx={{
        background: C.surface,
        border: `1px solid ${C.border}`,
        borderRadius: R.lg,
        overflow: "hidden",
        transition: `box-shadow ${trans}`,
        "&:hover": { boxShadow: S.md },
      }}
    >
      <Box
        onClick={() => setOpen((o) => !o)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "1.5rem",
          cursor: "pointer",
          userSelect: "none",
          gap: "1rem",
        }}
      >
        <Box
          sx={{ display: "flex", alignItems: "center", gap: "1rem", flex: 1 }}
        >
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: "10px",
              flexShrink: 0,
              overflow: "hidden",
            }}
          >
            <Box
              component="img"
              src={patho.img}
              alt={`Traitement ostéopathique — ${patho.title}`}
              sx={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: ".62rem",
                fontWeight: 600,
                letterSpacing: "2px",
                textTransform: "uppercase",
                color: C.accent,
                mb: ".25rem",
              }}
            >
              {patho.tag}
            </Typography>
            <Typography
              sx={{
                fontSize: ".95rem",
                fontWeight: 600,
                color: C.text,
                lineHeight: 1.3,
              }}
            >
              {patho.title}
            </Typography>
          </Box>
        </Box>
        <Box
          component="span"
          sx={{
            fontSize: ".7rem",
            fontWeight: 600,
            letterSpacing: "1px",
            textTransform: "uppercase",
            color: "rgba(196,97,76,.75)",
            background: "rgba(196,97,76,.08)",
            padding: ".2rem .55rem",
            borderRadius: "4px",
            whiteSpace: "nowrap",
          }}
        >
          {patho.count}
        </Box>
        <Box
          component="span"
          sx={{
            width: 28,
            height: 28,
            borderRadius: "50%",
            border: open
              ? `1.5px solid ${C.accent}`
              : `1.5px solid ${C.border}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: open ? "#fff" : C.textMuted,
            background: open ? C.accent : "transparent",
            fontSize: ".9rem",
            fontWeight: 300,
            transition: `all ${trans}`,
            flexShrink: 0,
            lineHeight: 1,
            transform: open ? "rotate(45deg)" : "none",
          }}
        >
          +
        </Box>
      </Box>
      <Box
        sx={{
          maxHeight: open ? "400px" : 0,
          overflow: "hidden",
          transition: "max-height .35s ease",
          px: "1.5rem",
          pb: open ? "1.5rem" : 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: ".35rem",
            borderTop: `1px solid ${C.border}`,
            pt: "1rem",
          }}
        >
          {patho.items.map((item) => (
            <Typography
              key={item}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: ".6rem",
                fontSize: ".83rem",
                color: C.textMuted,
                "&::before": { content: '"–"', color: C.accent, flexShrink: 0 },
              }}
            >
              {item}
            </Typography>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

const Pathologies = () => (
  <>
    <SEO
      title="Pathologies traitées en ostéopathie  Balma & Castelnau"
      description="Douleurs du dos, cervicales, migraines, troubles digestifs, sciatique, tendinites… Découvrez les pathologies prises en charge par Maxime Nicolaieff, ostéopathe à Balma."
      path="/pathologies"
      schema={{
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Accueil",
            item: "https://www.balma-osteopathe.fr/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Pathologies",
            item: "https://www.balma-osteopathe.fr/pathologies",
          },
        ],
      }}
    />
    <Box component="section" sx={SX.pageHeroSection}>
      <Box sx={SX.pageHeroInner}>
        <Box component="span" sx={SX.sectionLabel}>
          Pathologies
        </Box>
        <Typography variant="h1" component="h1" sx={SX.displayTitle}>
          Ce que je soigne, <em>au quotidien.</em>
        </Typography>
        <Typography sx={SX.pageHeroSub}>
          L'ostéopathie agit sur un large éventail de troubles fonctionnels.
          Retrouvez ici les principales pathologies traitées au cabinet.
        </Typography>
      </Box>
    </Box>

    <Box
      sx={{
        maxWidth: maxW,
        mx: "auto",
        px: { xs: "1rem", md: "2.5rem" },
        pb: { xs: "4rem", md: "5rem" },
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
        gap: "1.25rem",
        alignItems: "start",
      }}
    >
      {PATHOS.map((p) => (
        <PathoCard key={p.title} patho={p} />
      ))}
    </Box>

    {/* ── Profils dédiés ────────────────────── */}
    <Box component="section" sx={{ background: C.bgAlt, py: "5rem" }}>
      <Box
        sx={{ maxWidth: maxW, mx: "auto", px: { xs: "1rem", md: "2.5rem" } }}
      >
        <Box component="span" sx={SX.sectionLabel}>
          Pages dédiées
        </Box>
        <Typography
          variant="h2"
          component="h2"
          sx={{ ...SX.displayTitle, mb: "2.5rem" }}
        >
          Pages dédiées, <em>selon votre pathologie.</em>
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(3, 1fr)" },
            gap: "1.25rem",
          }}
        >
          {PROFILS.map((p) => (
            <Box
              key={p.name}
              component={Link}
              to={p.to}
              sx={{
                borderRadius: R.lg,
                overflow: "hidden",
                height: "240px",
                position: "relative",
                textDecoration: "none",
                display: "block",
                "&:hover img": { transform: "scale(1.04)" },
              }}
            >
              <Box
                component="img"
                src={p.img}
                alt={p.name}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: p.imgPos || "center",
                  transition: "transform .5s ease",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(to top, rgba(17,29,20,.72) 0%, transparent 55%)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  padding: "1.5rem",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: F.display,
                    fontSize: "1.2rem",
                    fontWeight: 400,
                    color: "#fff",
                    mb: ".2rem",
                  }}
                >
                  {p.name}
                </Typography>
                <Typography
                  sx={{
                    fontSize: ".72rem",
                    color: "rgba(255,255,255,.6)",
                    "&::after": { content: '" →"' },
                  }}
                >
                  Voir la page
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>

    {/* ── Avertissement ─────────────────────── */}
    <Box component="section" sx={{ background: C.dark, py: "5rem" }}>
      <Box
        sx={{
          maxWidth: maxW,
          mx: "auto",
          px: { xs: "1rem", md: "2.5rem" },
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: { xs: "2.5rem", md: "4rem" },
          alignItems: "start",
        }}
      >
        <Box>
          <Box component="span" sx={SX.sectionLabelWhite}>
            À savoir avant votre séance
          </Box>
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontFamily: F.display,
              fontSize: "clamp(1.8rem, 3vw, 2.5rem)",
              fontWeight: 300,
              color: "#fff",
              lineHeight: 1.2,
              mb: "1rem",
              "& em": { fontStyle: "italic", color: C.accent },
            }}
          >
            Certaines situations <em>nécessitent</em> un avis médical préalable.
          </Typography>
          <Typography
            sx={{ fontSize: ".85rem", color: "rgba(255,255,255,.5)", lineHeight: 1.75, mb: "2rem" }}
          >
            L'ostéopathie est une médecine complémentaire. Dans certains cas,
            une consultation médicale est recommandée avant de commencer le
            traitement.
          </Typography>
          <Box
            sx={{
              borderLeft: `3px solid ${C.accent}`,
              pl: "1.25rem",
              fontSize: ".82rem",
              color: "rgba(255,255,255,.45)",
              lineHeight: 1.75,
              fontStyle: "italic",
            }}
          >
            En cas de doute, n'hésitez pas à me contacter — nous trouverons
            ensemble la meilleure approche pour vous accompagner.
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: ".6rem" }}>
          {WARNING_ITEMS.map((w) => (
            <Box
              key={w.title}
              sx={{
                display: "grid",
                gridTemplateColumns: "36px 1fr",
                gap: ".75rem",
                alignItems: "start",
                padding: "1rem 1.25rem",
                background: "rgba(255,255,255,.05)",
                borderRadius: R.base,
                border: "1px solid rgba(255,255,255,.08)",
                transition: `background ${trans}`,
                "&:hover": { background: "rgba(255,255,255,.08)" },
              }}
            >
              <Box
                component="span"
                sx={{ fontSize: "1.1rem", lineHeight: 1, pt: ".15rem" }}
              >
                {w.icon}
              </Box>
              <Box>
                <Typography
                  sx={{ fontSize: ".85rem", fontWeight: 600, color: "rgba(255,255,255,.8)", mb: ".2rem" }}
                >
                  {w.title}
                </Typography>
                <Typography
                  sx={{ fontSize: ".75rem", color: "rgba(255,255,255,.4)", lineHeight: 1.5 }}
                >
                  {w.desc}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  </>
);

export default Pathologies;
